<template>
  <div class="forgot_footer">
    <!-- <div class="app_links">
      <div class="links_list">
        <el-row :gutter="10">
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.ABOUTUS')}}</router-link>
          </el-col>
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.RECRUITMENT')}}</router-link>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.ADSERVICE')}}</router-link>
          </el-col>
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.SALESALLIANCE')}}</router-link>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.CONTACTUS')}}</router-link>
          </el-col>
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.MERCHANTSSETTLED')}}</router-link>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >{{$t('common_pageText.LINKS')}}</router-link>
          </el-col>
          <el-col :span="12">
            <router-link
              to=""
              class="links_link white"
            >English Site</router-link>
          </el-col>
        </el-row>
      </div>
      <div class="app_about white">
        <span class="app_about_title size-20">{{$t('common_pageText.LOGIN_TITLE')}}</span>
        <span class="app_about_info">{{$t('common_pageText.CONTACTUS')}}</span>
        <span class="app_about_info">{{$t('common_pageText.COMPHONE')}}</span>
        <span class="app_about_info">{{$t('common_pageText.COMADDRNAME')}}：{{$t('common_pageText.COMADDR')}}</span>
        <span class="app_about_info">{{$t('common_pageText.RESEARCHBASENAME')}}：{{$t('common_pageText.RESEARCHBASE')}}</span>
      </div>
    </div> -->
    <div class="copyright_info white">
      <span
        >COPYRIGHT&nbsp;&nbsp; © 2010-2021&nbsp;&nbsp;SAMEX Systems
        Limited.&nbsp;&nbsp;</span
      >
      <span>{{ pageText.copyRight }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pageText: {
        copyRight: this.$t("common_pageText.COPYRIGHT")
      }
    };
  },
  watch: {
    "$i18n.locale"(curVal, oldVal) {
      this.pageText.copyRight = this.$t("common_pageText.COPYRIGHT");
    }
  }
};
</script>
<style scoped>
.forgot_footer {
  width: 100%;
  height: 20px;
  color: #9b9ea0;
  background-color: #313131;
  text-align: left;
  overflow: hidden;
}
.app_links {
  display: flex;
  padding-top: 50px;
  box-sizing: border-box;
}
.links_list {
  display: block;
  flex: 1;
}
.links_list > .el-row {
  width: 600px;
  margin: 0 auto 15px auto;
  padding-left: 250px;
}
.links_link {
  display: inline-block;
  font-weight: lighter;
}
.links_link:hover {
  color: #ffa000;
}
.app_about {
  display: block;
  flex: 1;
  border-left: 1px solid #1b1b1b;
  box-sizing: border-box;
}
.app_about_title {
  display: block;
  color: #ffa000;
  margin: 0 auto 15px auto;
  padding-left: 200px;
}
.app_about_info {
  display: block;
  margin: 0 auto 15px auto;
  padding-left: 200px;
}
.copyright_info {
  display: block;
  /* padding-left: 250px; */
  padding: 0 10px;
  text-align: right;
}
</style>


